import {RootState} from '../../shared/state/root-reducer';
import {UserRolePage} from '../model/user-role-page';
import {UserRolePageAction} from '../model/user-role-page-action';
import {useSelector} from 'react-redux';

interface IAccessControlProps {
  rolePageName: string;
  actionName: string;
  children: any;
  renderNoAccess: any;
  isAccountHolderPortal?: boolean;
  strategy?: {
    type: 'pageOnlyWithEdit'
  }
}

export const checkPermissions = (userRolePages: UserRolePage[], rolePageName: string, actionName: string, isAccountHolderPortal: boolean) => {
  if (userRolePages.length === 0) {
    return true;
  }

  // Get the page from the user role pages
  const userRolePage = userRolePages.find((page: UserRolePage) => { return page?.sysRolePage?.rolePageName === rolePageName });
  //  If RolePage does not exist, we need to return false
  if (!userRolePage) {
    return false;
  }
  // Check if the page is readonly, if it's read only, then no need to check the page actions.
  if (userRolePage?.isReadOnly) {
    return false;
  }
  return (
    userRolePage?.userRolePageActions?.findIndex(
      (action: UserRolePageAction) => {
        return (action?.sysRolePageAction?.actionName === actionName &&
            (action.isEnabled || isAccountHolderPortal));
      }
    ) !== -1
  );
};

// Returns true if the specified role page exists within the user's assigned role pages and it's set to isEnabled
export const checkUserRolePage = (
  userRolePages: UserRolePage[],
  rolePageName: string
): boolean => {
  return userRolePages.some(
      page =>
          page?.sysRolePage?.rolePageName === rolePageName &&
          page?.isEnabled === true
  );
};

export const checkViewOnlyPermissions = (userRolePages: UserRolePage[], rolePageName: string, actionName: string, isAccountHolderPortal: boolean) => {
  //super user check can view all pages
  if (userRolePages.length === 0) {
    return true;
  }
  // Get the page from the user role pages
  const userRolePage = userRolePages.find((page: UserRolePage) => { return page?.sysRolePage?.rolePageName === rolePageName });
  // Check if the page is readonly, if it's read only, then return true
  if (userRolePage) {
    return true;  // Changed from false to true
  }
};

export const checkPagePermission = ({
                               userRolePages,
                               rolePageName,
                               permitReadOnly
}: {
  userRolePages: UserRolePage[],
  rolePageName: string
  permitReadOnly: boolean
}) => {

  const response = userRolePages.find((page: UserRolePage) => {
    return (page?.sysRolePage?.rolePageName === rolePageName) &&
    (page.isEnabled) &&
        (permitReadOnly ? true : !page.isReadOnly)
  })

  return !!response

}

const AccessControl = ({
                         rolePageName,
                         actionName,
                         children,
                         renderNoAccess,
                         isAccountHolderPortal = false,
                         strategy
}: IAccessControlProps) => {

  const userRolePages = useSelector(
    (state: RootState) => state.userContext.userProfile.userRole.userRolePages
  );


  let permitted;

  switch(strategy?.type){

    case 'pageOnlyWithEdit' :
      permitted = checkPagePermission({
        userRolePages,
        rolePageName,
        permitReadOnly: false
      })

      break;

    default:
      permitted = checkPermissions(userRolePages, rolePageName, actionName, isAccountHolderPortal);
  }

  if (permitted) {
    return children;
  } else {
    return renderNoAccess();
  }
};

AccessControl.defaultProps = {
  renderNoAccess: () => null,
};

export default AccessControl;